import {MdEmail} from "react-icons/md"
import {FaLinkedinIn} from "react-icons/fa"
import {AiFillGithub} from "react-icons/ai"
import {MdCall} from "react-icons/md"
import { Flex, Icon } from "@chakra-ui/react"
import { Text as ChakraText } from '@chakra-ui/react'
import Heading from "./Heading";
import Text from "./Text";
import { wrap } from "framer-motion"

export default function Contact({id}){
    return (

        <div
        id={id}
        
        style={{
          width: '100%',
          scrollBehavior:"smooth",
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '64px',
          marginBottom:"64px",
        }}
      >
      <Heading text={'Contact Me'} size="md" />
{/* <div style={{
            display: 'flex',
            flexDirection:"column",
            gap:"10px",
            width: '60%',
            marginTop: '32px',
            alignItems:"center"
          }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap:"10px",
            width: '60%',
            marginTop: '32px',
          }}
        > */}
                  <Flex direction={"column"} flexWrap={wrap} gap={"10px"}  marginTop={'20px'}>
                  <Flex direction={{base:"column", sm:"row",md:"row"}} justifyContent={"center"} gap={"4px"} alignItems={"center"}>
           <a target="_blank" rel="noopener noreferrer" id="contact-email" href="mailto:bhishree19@gmail.com"> <Icon as={MdEmail}></Icon></a>
        <Text style={{ textAlign: 'center' }} size="md">
            {`bhishree19@gmail.com`}
        </Text>
        </Flex>
        <Flex justifyContent={"center"} gap={"4px"} alignItems={"center"}>
            <Icon as={MdCall}></Icon>
        <ChakraText fontSize = '18px' textAlign= 'center' size="md" id="contact-phone">
            {`+91 9625352616`}
        </ChakraText>
        
        </Flex>
        <Flex direction={"row"} gap={"4px"} justifyContent={"center"} alignItems={"flex-end"}>
        <a href="https://github.com/Abhishree-codes" id="contact-github" target="_blank" rel="noopener noreferrer"> <Icon  as={AiFillGithub}></Icon></a>
        <Text style={{ textAlign: 'center' }} size="md">
            {`GitHub`}
        </Text>
        <Text>{"|"}</Text>
        <a href="https://www.linkedin.com/in/abhishree-tripathi-7b419a17a/" target="_blank" rel="noopener noreferrer" id="contact-linkedin"><Icon  as ={FaLinkedinIn}></Icon></a>
        <Text style={{ textAlign: 'center' }} size="md">
            {`LinkedIn`}
        </Text>
        </Flex>
                  </Flex>
          </div>
        //   </div>
        // </div>
    )
}